<template>
  <!-- 主页 -->
  <div class="home">
    <!-- bannar+标语 -->
    <div class="bannar">
      <!-- <img src="../../public/img/contactus/bannar.jpg" /> -->
      <div class="bigtitle">
        <p class="bannerdes1">联系我们</p>
        <p class="bannerdes2">Contact us</p>
        <div class="bannaerline"></div>
        <p class="bannerdes3">
          对产品、技术支持、合作等有任何问题，请<br />通过这些渠道与我们联系
        </p>
      </div>
    </div>
    <!-- 联系我们 -->
    <div class="model model1">
      <i class="position"></i>
      <Minetitle2 :title1="titleArr[0].title1" :title2="titleArr[0].title2" />
      <div class="model1_floor1 clearfix">
        <div class="model1_arr fl" style="padding-left: 58px">
          <img src="../../public/img/contactus/icon1.png" alt="" />
          <p class="model1_des">联系电话：</p>
          <p class="model1_detail clearfix">0571-86758610</p>
        </div>
        <div class="model1_arr fr">
          <img src="../../public/img/contactus/icon2.png" alt="" />
          <p class="model1_des">E-mail：</p>
          <p class="model1_detail clearfix">wefly181223@163.com</p>
        </div>
      </div>
      <div class="model1_floor2">
        <div class="mapDemo">
          <div class="mapTitle">
            <p class="mapDes1">公司分布区域图</p>
            <p class="mapDes2">Company distribution map</p>
          </div>
          <div id="chinaMap" :style="{ width: '100%', height: '100%' }" />
        </div>
      </div>
    </div>
    <!-- 在线留言 -->
    <div class="model model2">
      <i class="position"></i>
      <Minetitle2 :title1="titleArr[1].title1" :title2="titleArr[1].title2" />
      <el-form ref="form" :model="form">
        <div class="model2floor1">
          <el-form-item class="model2item">
            <el-input v-model="form.name" placeholder="姓名："></el-input
          ></el-form-item>
          <el-form-item class="model2item">
            <el-input v-model="form.tel" placeholder="电话："></el-input
          ></el-form-item>
          <el-form-item class="model2item">
            <el-input v-model="form.email" placeholder="邮箱："></el-input
          ></el-form-item>
        </div>
        <el-form-item class="model2floor2">
          <el-input
            type="textarea"
            v-model="form.context"
            placeholder="请输入留言："
            :autosize="false"
            maxlength="200"
            resize="none"
          ></el-input>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button @click="resert">重置</el-button>
          <el-button type="primary" @click="submit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import Minetitle2 from "../components/minetitle2.vue";
import echarts from "echarts";
import { postPv } from "@/api/postPv";

// @ is an alias to /src
export default {
  name: "Contactus",
  data() {
    return {
      activeName: "item0",
      //题目组
      titleArr: [
        { id: 1, title1: "联系方式", title2: "contact information" },
        { id: 2, title1: "在线留言", title2: "Online Message" },
      ],
      form: {}, //表格绑定数据,

      mapData: [], //map的数据用于formatter
      mapData2: [], //map的数据2用于visualMap;
      myChart: {},
    };
  },
  watch: {
    // 监控滚动距离和vw
  },
  methods: {
    tableclick() {
      //切换标题栏跳转
    },
    submit() {
      this.form = {
        name: "",
        tel: "",
        email: "",
        context: "",
      };
      this.$notify({
        offset: 100,
        title: "成功",
        message: "感谢您的留言",
        type: "success",
        duration: 2500,
      });
    },
    resert() {
      this.form = {
        name: "",
        tel: "",
        email: "",
        context: "",
      };
    },
    //进来获取数据
    getData(params) {
      // //console.log(province,city)
      var thiz = this;
      let arr = [
        {
          name: "阜平县",
          value: [114.198801, 38.847276],
          datas: 1354,
          img: "image://asset/get/s/data-1619059442567-s5l7-f8Eu9.png",
        },
        {
          name: "涞源县",
          value: [114.723966, 39.292095],
          datas: 1402,
          img: "image://asset/get/s/data-1619059442567-s5l7-f8Eu9.png",
        },
        {
          name: "易县",
          value: [115.245576, 39.311674],
          datas: 2468,
          img: "image://asset/get/s/data-1619059838735-QE9mBZmhh.png",
        },
        {
          name: "定州市",
          value: [115.050014, 38.460198],
          datas: 768,
          img: "image://asset/get/s/data-1619321685306-EvjlgDOXi.png",
        },
        {
          name: "曲阳县",
          value: [114.654083, 38.700813],
          datas: 589,
          img: "image://asset/get/s/data-1619059838735-QE9mBZmhh.png",
        },
        {
          name: "唐县",
          value: [114.798254, 38.898656],
          datas: 1500,
          img: "image://asset/get/s/data-1619321685306-EvjlgDOXi.png",
        },
      ];
      thiz.drawChinaMap(arr);
    },
    //绘制chinaMap
    drawChinaMap(provData) {
      var thiz = this;
      this.myChart = this.$echarts.init(document.getElementById("chinaMap"));
      // 这里依据屏幕大小配置
      const clientWidth = document.body.clientWidth;
      let layoutSize = "100%";
      if (clientWidth >= 1920) {
        layoutSize = "120%";
      } else if (clientWidth < 1920 && clientWidth >= 1600) {
        layoutSize = "100%";
      } else {
        layoutSize = "100%";
      }

      var provData = [
        {
          name: "湖州蔚复来为民环保科技有限公司",
          value: [
            119.988211,
            30.527447,
            "浙江省湖州市德清县舞阳街道科源路\n\n\n\t\t11号4幢258室（莫干山国家高新区）",
          ],
        },
        {
          name: "丽水蔚复来为民环保科技有限公司",
          value: [
            119.912261,
            28.47115,
            "浙江省丽水市莲都区城北街368号\n\n\n\t\t绿谷信息产业园3号楼5层501",
          ],
        },
        {
          name: "嘉兴蔚复来为民环保科技有限公司",
          value: [
            120.930662,
            30.849471,
            "浙江省嘉兴市嘉善县魏塘街道解放东\n\n\n\t\t路35号1幢四楼",
          ],
        },
        {
          name: "福建蔚复来环保科技有限公司",
          value: [
            119.318935,
            26.136758,
            "福建省福州市晋安区新店镇南平东路\n\n\n\t\t98号金城投资区工业中心B1号春雨阁10204",
          ],
        },
        {
          name: "滁州市蔚复来为民环保科技有限公司",
          value: [
            119.019211,
            32.685528,
            "天长市城南街道城南办事处八里村村部1-1",
          ],
        },
        {
          name: "蔚复来（浙江）科技股份有限公司合肥分公司",
          value: [
            117.255809,
            31.882847,
            "安徽省合肥市庐阳区合作化北路桥西北\n\n\n\t\t侧思和苑集贸市场5＃商网4层1号",
          ],
        },
        {
          name: "蔚复来（浙江）科技股份有限公司嘉善分公司",
          value: [
            120.930662,
            30.849471,
            "浙江省嘉兴市嘉善县魏塘街道解放东路\n\n\n\t\t35号1幢301室",
          ],
        },
        {
          name: "蔚复来（浙江）科技股份有限公司宜春分公司",
          value: [
            115.554744,
            28.046885,
            "江西省宜春市樟树市四特大道202号(新\n\n\n\t\t天国际)三期1幢11层2-1103号",
          ],
        },
        {
          name: "蔚复来（浙江）科技股份有限公司池州分公司",
          value: [
            117.653094,
            30.7657,
            "安徽省池州市直属园区江南集中区江之\n\n\n\t\t南科技孵化园z3栋3楼305室",
          ],
        },
        {
          name: "蔚复来（浙江）科技股份有限公司深圳分公司",
          value: [
            113.927459,
            22.505914,
            "深圳市南山区招商街道沿山社区南海大\n\n\n\t\t道1081号悠然居C-10C",
          ],
        },
      ];
      // //console.log(provData);

      var obj = {
        xAxis: {
          show: false,
          type: "value",
        },
        yAxis: {
          show: false,
          type: "value",
        },
        // 漫步-开启缩放和拖动
        roam: true,
        zoom: 30,
        // 滚轮缩放控制
        scaleLimit: {
          min: 0.8,
          max: 3,
        },
        geo: {
          map: "china",
          show: true,
          roam: true,
          label: {
            normal: {
              show: true,
              color: "white",
              fontSize: 14,
            },
            emphasis: {
              show: true,
              fontSize: 14,
              color: "white",
            },
          },
          itemStyle: {
            normal: {
              areaColor: "RGBA(35, 51, 77, 1)",
              borderColor: "RGBA(30, 157, 164, 1)",
              borderWidth: 2,
            },
            emphasis: {
              areaColor: "RGBA(68, 81, 103, 1)",
              color: "RGBA(30, 157, 164, 1)",
            },
          },
        },
        visualMap: [
          {
            min: 0,
            max: 5,
            show: false,
          },
        ],

        series: [
          {
            map: "china",
            // 需要设置layoutCenter，layoutSize才会有效
            layoutSize: layoutSize,
            type: "scatter",
            coordinateSystem: "geo",
            symbol: "pin", //气泡
            data: provData,
            symbolSize: function (val) {
              return 25;
            },
            // symbol:'../img/contactus/icon4.png',
            label: {
              normal: {
                position: "right",
                show: false,
              },
              emphasis: {
                show: true,
                postion: "right",
                textStyle: {
                  color: "white",
                  fontSize: 14,
                },
                backgroundColor: "rgba(42, 42, 42, 1)",
                borderColor: "RGBA(31, 146, 155, 1)",
                borderWidth: 1,
                borderRadius: 4,
                padding: [0, 8],
                formatter: function (res) {
                  let arr = res.data;
                  //console.log(arr)
                  let name = arr.name;
                  let address = arr.value[2];

                  let html = `\n\n  ${name}\n\n\n  地址：${address} \n\n `;
                  return html;
                },
              },
            },
            itemStyle: {
              normal: {
                color: "RGBA(88, 158, 218, 1)",
              },
              emphasis: {
                color: "RGBA(99, 185, 119, 1)",
              },
            },
            zlevel: 1,
          },
        ],
      };
      this.myChart.setOption(obj);
    },
  },
  mounted() {
    this.$nextTick(() => {
      //接口走数据
      this.getData();
      postPv("https://www.azureflying.com/api/blade-website/analytics/access")
        .then((res) => {})
        .catch((err) => {});
      //发送pv
    });
  },
  inject: ["reload"],
  components: { Minetitle2 },
};
</script>
<style scoped>
/* 测试 */
.echart {
  width: 600px;
  height: 800px;
}

/*  */
.home {
  width: 100%;
  overflow-x: hidden;
  padding-top: 80px;
}
.bannar {
  width: 100%;
  height: 673px;
  margin-bottom: 89px;
  position: relative;
  background: url("../../public/img/contactus/bannar.jpg") no-repeat;
  background-size: cover;
}
/* .bannar img {
  width: 100%;
  height: 100%;
} */
.bigtitle {
  width: 650px;
  position: absolute;
  left: 353px;
  top: 125px;
}
.bannerdes1 {
  font-size: 76px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  line-height: 72px;
  margin-bottom: 32px;
  letter-spacing: 10px;
}
.bannerdes2 {
  font-size: 40px;
  line-height: 40px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #666666;
  margin-bottom: 60px;
  letter-spacing: 3px;
}
.bannaerline {
  width: 68px;
  height: 6px;
  background: #cccccc;
  margin-bottom: 30px;
}
.bannerdes3 {
  width: 100%;
  height: auto;
  font-size: 30px;
  font-family: Source Han Sans CN;
  font-weight: 300;
  color: #999999;
}

/* 公司简介 */
.model {
  width: 80%;
  max-width: 1360px;
  margin: 0 auto;
  position: relative;
}

.model1 {
  height: auto;
}
.model2 {
  height: auto;
}
/*  */
.model1_floor1 {
  padding-top: 60px;
  margin-bottom: 68px;
}
.model1_arr {
}
.model1_arr img {
  width: 40px;
  height: 40px;
  float: left;
  margin-right: 26px;
}
.model1_des {
  float: left;
  height: auto;
  line-height: 40px;
  color: #999999;
  font-size: 24px;
}
.model1_detail {
  color: #589ef8;
  font-size: 30px;
  padding-left: 70px;
  line-height: 70px;
}
.model1_floor2 {
  width: 100%;
  height: 1200px;
  margin-bottom: 68px;
  border-radius: 6px;
}
/* 留言 */
.model2floor1 {
  width: 100%;
  display: flex;
  height: 54px;
  justify-content: space-between;
  margin-bottom: 29px;
}
.model2item {
  width: 388px;
  height: 100%;
  /* border: 1px solid #CCCCCC; */
  border-radius: 5px;
}

.mapDemo {
  width: 100%;
  height: 100%;
  position: relative !important;
  background: url("../../public/img/contactus/bg_map.png") no-repeat;
  background-size: cover;
}
.position {
  position: relative;
  z-index: -1;
  left: 0;
  top: -180px;
}

.mapTitle {
  width: auto;
  height: auto;
  position: absolute;
  left: 54px;
  top: 54px;
}
.mapDes1 {
  font-size: 30px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #fdfdfd;
}
.mapDes2 {
  font-size: 18px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #fffefe;
  white-space: nowrap;
}
</style>